<template>
  <div class="home">
    <div class="home_body2">
      <div class="home_tit">{{ $t("beth_text.Account_Balance") }}</div>
      <div class="home_row">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="8" :md="8" :lg="8">
            <div class="h_box">
              <div>
                <img
                  class="h_box2"
                  src="../../assets/img/home_icon1.png"
                  alt=""
                />
              </div>
              <div class="h_box3">{{ $t("main.text40") }}</div>
              <div class="h_box4">{{ set_num3_2(home_data.usdt_balance) }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8" :lg="8">
            <div class="h_box">
              <div>
                <img
                  class="h_box2"
                  style="opacity: inherit"
                  src="../../assets/img/home_icon2.png"
                  alt=""
                />
              </div>
              <div class="h_box3">{{ $t("main.text41") }}</div>
              <div class="h_box4">{{ set_num3_2(home_data.usdc_balance) }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 卡片组件 -->
    <CardBox>
      <div slot="card_title" class="home_tit">{{ $t("main.text688") }}</div>
    </CardBox>

    <!-- 系统公告 -->
    <el-dialog
      v-if="unread_list && unread_list[0]"
      :title="$t('beth_text.system_notice')"
      :visible.sync="affiche_dlg"
      custom-class="dlg element_input add_dlg dlg_height"
      append-to-body
      center
      width="500px"
      :before-close="affiche_dlg_close"
      @close="handle_close"
    >
      <div class="dlg_body">
        <div class="d_body">
          <div class="aff_title">{{ unread_list[0].title }}</div>
          <div class="aff_text" v-html="unread_list[0].content"></div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">&nbsp;</span>
    </el-dialog>
  </div>
</template>

<script>
import { home } from "@/api/api";
import CardBox from "../../component/card";
import { msg_box, read } from "@/api/api";

export default {
  components: {
    CardBox,
  },
  data() {
    return {
      home_data: {
        box_status: "",
        btc_balance: "",
        eth_balance: "",
        kyc_bank_info: {
          account_number: "",
          bank_name: "",
          referral_code: "",
        },
        sgd_balance: "",
        usd_balance: "",
        usdc_balance: "",
        usdt_balance: "",
      },
      welcome_dlg: false,
      text_show: false,

      affiche_dlg: false,
      unread_list: [], //首页未读数据 每个都要弹框
    };
  },
  mounted() {
    this.get_list();
    this.get_affiche_list();

    this.setupFreshchat();
  },
  watch: {
    "$store.state.freshchatLoaded": function () {
      this.setupFreshchat();
    },
  },
  methods: {
    setupFreshchat() {
      if (!this.$store.state.freshchatLoaded) return;
      if(!window.fcWidget) return;
      if (window.fcWidget.isInitialized()) return;

      window.fcWidget.init({
        token: process.env.VUE_APP_FC_TOKEN,
        host: "https://wchat.freshchat.com",
        externalId: this.$store.state.userid,
        firstName: this.$store.state.username,
        email: this.$store.state.email,
      });
    },
    get_list() {
      home().then((res) => {
        if (res.data.code == 200) {
          this.home_data = res.data.data;
          // console.log(res.data.data);
        }
      });
    },
    async affiche_dlg_close(done) {
      const res = await read({ ids: [this.unread_list[0].id] });
      if (res.data.code != 200) {
        return this.message.ismessage("error", res.data.msg);
      }
      this.unread_list.shift();
      done();
      this.affiche_dlg = false;
    },
    handle_close() {
      if (this.unread_list && this.unread_list[0]) {
        setTimeout(() => {
          this.affiche_dlg = true;
        }, 300);
      }
      if (this.unread_list.length <= 0) {
        this.bus.$emit("request_unread_num", true);
      }
    },
    async get_affiche_list() {
      const res = await msg_box();
      if (res.data.code != 200) {
        return this.message.ismessage("error", res.data.msg);
      }
      const d = res.data.data;
      if (d.length) {
        for (const item of d) {
          if (item.is_read == 0) {
            this.unread_list.push(item);
          }
        }
        if (this.unread_list && this.unread_list[0]) {
          this.affiche_dlg = true;
        }
      }
    },
  },
};
</script>

<style scoped>
/* 滚动条 */
/* .home {
  overflow-y: auto;
  height: calc(100vh - 80px);
}
.home::-webkit-scrollbar {
  width: 5px;
}
.home::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #687eec;
} */
/* --over-- */

.h_box {
  background: #232a36;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 28px;
  color: #fff;
  min-height: 214px;
}
.home_row {
  margin-bottom: 20px;
}
.h_box2 {
  max-height: 60px;
  opacity: 0.2;
}
.h_box3 {
  font-size: 15px;
  margin-top: 25px;
  margin-bottom: 12px;
}
.h_box4 {
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
}

/* 退出弹框 */
.log_out1 img {
  width: 40px;
  display: block;
  margin: auto;
}
.log_out2 {
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  text-align: center;
  color: #ffffff;
  /* margin-top: 16px; */
}
.log_out3 {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;
  color: #ffffff;
  opacity: 0.8;
  margin-top: 8px;
  text-align: center;
  box-sizing: border-box;
  padding: 0 75px;
  word-break: break-word;
  word-wrap: break-word;
}
.cancel_btn {
  color: #f1c788;
  border-color: #f1c788;
  background: transparent;
}
.confirm_btn {
  width: 163px;
  height: 38px;
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  border-color: #f1c788;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  text-align: center;
  color: #04182a;
  /* margin-left: 20px; */
  margin-bottom: 15px;
}
.do_it_later {
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  text-decoration-line: underline;
  color: #deb981;
  text-align: center;
  cursor: pointer;
  margin-bottom: 15px;
}
/* --over-- */
.welcome_main {
  box-sizing: border-box;
  padding: 40px;
  color: #fff;
  padding-bottom: 0;
}
.w_main {
  box-sizing: border-box;
  padding: 20px;
  background: #04182a;
  border-radius: 16px;
  margin-bottom: 20px;
}
.w_main_two {
  display: flex;
  background: #04182a;
  align-items: center;
}

.w_main1 img {
  width: 218px;
  border-radius: 16px;
  margin-right: 15px;
}
.w_main_t1 {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  /* line-height: 26px; */
  margin-bottom: 8px;
  word-break: break-word;
  word-wrap: break-word;
}
.w_main_t2 {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  opacity: 0.8;
  margin-bottom: 16px;
  word-break: break-word;
  word-wrap: break-word;
}
.w_main_btn,
.w_main_btn:hover {
  min-width: 160px;
  height: 38px;
  line-height: 38px;
  padding: 0;
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  border-color: #f1c788;
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  text-align: center;
  color: #04182a;
}
.text_b {
  border-top: 1px solid #404f5d;
  margin-top: 16px;
  box-sizing: border-box;
  padding-top: 16px;
}
.text_b_t1 {
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  margin-bottom: 10px;
}
.text_b_t2 {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  opacity: 0.8;
  margin-bottom: 6px;
}
.text_b_t3 {
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  color: #deb981;
  cursor: pointer;
}
.icon_check {
  margin-right: 6px;
}
.text_btm {
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  text-decoration-line: underline;
  color: #deb981;
}
.text_btm span {
  cursor: pointer;
}
.home_tit {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 16px;
}
.home_body1_1 {
  background: #04182a;
  border-radius: 16px;
  /* margin: 28px; */
  box-sizing: border-box;
  padding: 28px;
  display: flex;
  margin-bottom: 60px;
}
.body1_tit1 {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  opacity: 0.6;
  margin-bottom: 8px;
}
.body1_tit2 {
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 20px;
}
.h_b_box {
  padding-right: 28px;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  padding-left: 28px;
}
.home_body1_1 .h_b_box:last-child {
  border-right: none;
  padding-right: 0;
}
.home_body1_1 .h_b_box:first-child {
  padding-left: 0;
}
.box_width1 {
  min-width: 257px;
}
.box_width2 {
  min-width: 111px;
}
.box_width3 {
  min-width: 88px;
}
/* ------ */
.h_box_green .h_box2 {
  opacity: 0.3;
}
.h_box_green .h_box3 {
  color: rgba(18, 186, 156, 0.8);
}
.h_box_green .h_box4 {
  color: rgba(18, 186, 156, 1);
}
.h_box_green .h_box2 {
  max-height: 48px;
}
.aff_title {
  font-size: 18px;
  margin-bottom: 10px;
}
.aff_text {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  word-break: break-word;
}
</style>
<style>
.welcome_dlg_height {
  /* background: #041E35 !important; */
  background: url("../../assets/img/welcome_dlg_bgc.png") no-repeat #041e35 !important;
  /* background-size: cover; */
  background-size: 100% 100% !important;
  color: #fff;
  border-radius: 16px;
}
.welcome_dlg_height .el-dialog__header {
  padding: 0 !important;
}
.welcome_dlg_height .el-dialog__headerbtn {
  text-align: right !important;
  width: 94%;
  display: inline-block;
}
.welcome_dlg_height .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
@media screen and (max-height: 747px) {
  .welcome_dlg_height {
    left: 50%;
    top: 0;
    transform: translate(-50%, 0);
    margin: 50px 0 !important;
  }
}
.wenhao {
  margin-left: 6px;
  cursor: pointer;
}
</style>

<style scoped>
/* 平板 */
@media screen and (min-width: 768px) and (max-width: 1200px) {
}
/* 手机  850 */
@media screen and (max-width: 767px) {
  .log_out3 {
    padding: 0;
  }
  .welcome_main {
    padding: 0;
  }
  .w_main_two {
    display: block;
  }
  .w_main_t1 {
    margin-top: 10px;
  }
  .h_box {
    margin-bottom: 15px;
  }
  .home_row {
    margin-bottom: 0;
  }
  .home_body1_1 {
    display: inherit;
  }
  .box_width1,
  .box_width2,
  .box_width3 {
    min-width: 100%;
  }
  .h_b_box {
    padding: 0;
    border: none;
  }
}
</style>

<style>
.dlg_height{
  max-height: 100vh;
  overflow-y: auto;
}
.dlg_height::-webkit-scrollbar {
  width: 5px;
}
.dlg_height::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #00c18e;
}
</style>